// extracted by mini-css-extract-plugin
export default {"modalZ":"100001","headerHeight":"80px","root":"gBddl","desktop":"JF9sf","tablet":"s9sbW","mobile":"z62Sg","smallMobile":"eeLa_","icon":"J54SJ","title":"Zc95V"};